import RowWithholdingTax from './RowWithholdingTax';

export default RowWithholdingTax;
